import { ArrowLeftOutlined } from "@ant-design/icons";
import { Button, Space, Table, Tag, Tooltip } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Card, CardBody, CardTitle, Col, Row } from "reactstrap";
import { requestBidRevision } from "../../../../api/bid.api";

function BidDetails() {
  const { id } = useParams();
  const history = useNavigate();
  const [loading, setLoading] = useState(false);
  const [lowestBid, setLowestBid] = useState("None");
  const [vendorBids, setVendorBids] = useState([]);
  const navigate = useNavigate();
  console.log("bid id", id);
  const goBack = () => {
    navigate(-1);
  };
  useEffect(() => {
    getLowestBid();
  }, [vendorBids]);
  const columns = [
    {
      title: "Vendor Name",
      key: "vendor_name",
      dataIndex: "name",
    },
    {
      title: "Bid Amount",
      key: "bid_amount",
      dataIndex: "total_bid_price",
    },
    {
      title: "Delivery Date",
      key: "delivery_date",
      dataIndex: "delivery_date",
    },

    // {
    //   title: "Status",
    //   key: "status",
    //   dataIndex: "status",
    // },
    {
      title: "Actions",
      key: "action",
      render: (data) => (
        <Space>
          {data?.vendor_bid_id ? (
            <>
              <Tag
                onClick={() => {
                  history(
                    `/app/project/biddings/biddetails/bidMoreDetail/${data.vendor_bid_id}`
                  );
                }}
                style={{ cursor: "pointer" }}
                color={"#2db7f5"}
              >
                View
              </Tag>
              {data?.revision_request ? (
                <Tooltip title="You have already requested bid revision from this vendor.">
                  <Tag style={{ cursor: "pointer" }} color={"#C0C7CB"}>
                    Requested Bid Revision
                  </Tag>
                </Tooltip>
              ) : (
                <Tag
                  onClick={() => {
                    requestBidRevision({
                      vendor_bid_id: data?.vendor_bid_id,
                      revision_comment: "",
                    }).then((res) => {
                      toast.success("Request sent!");
                    });
                  }}
                  style={{ cursor: "pointer" }}
                  color={"#108ee9"}
                >
                  Request Bid Revision
                </Tag>
              )}
            </>
          ) : (
            <Tag style={{ cursor: "pointer" }} color={"warning"}>
              Pending
            </Tag>
          )}
        </Space>
      ),
    },
  ];
  useEffect(() => {
    const getBidDetails = async () => {
      try {
        await axios.get(`apiV1/bid-report/?bid_id=${id}`).then((resp) => {
          console.log("Bid details", resp);
          setVendorBids(resp?.data.vendor_bid);
        });
      } catch (error) {
        console.log("cancelled", error);
      }
    };
    getBidDetails();
  }, []);

  const getLowestBid = async () => {
    let min = 1000000000;
    vendorBids?.map((bid) => {
      if (min > bid?.total_bid_price && bid?.total_bid_price > 0) {
        min = bid?.total_bid_price;
      }
      if (min != 1000000000) {
        setLowestBid(min);
      }
    });
  };

  const getHighestBid = () => {
    let max = Math.max(...vendorBids.map((item) => item.total_bid_price));

    if (max === 0 || !max) {
      return "None";
    }
    return max?.toFixed(2);
  };

  return (
    <React.Fragment>
      <Card
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexDirection: "row",
          padding: "18px 15px",
          marginBottom: "15px",
        }}
      >
        <div className="d-flex align-items-center">
          <ArrowLeftOutlined style={{ fontSize: "25px" }} onClick={goBack} />
          <div
            style={{
              marginBottom: "1px",
              marginLeft: "10px",
              fontSize: "20px",
              fontWeight: "600",
            }}
          >
            Bid Submissions
          </div>
          <CardTitle style={{ marginBottom: "0px", marginLeft: "17px" }}>
            {" "}
            Explore the submissions of various vendors on the bid that you
            raised
          </CardTitle>
        </div>
        <div>
          <Button
            type="primary"
            onClick={() => {
              history(`/app/project/biddings/bid-comparison/${id}`);
            }}
          >
            See bid Comparison
          </Button>
        </div>
      </Card>

      <Row>
        <Col>
          <Card>
            <Tag
              color="purple"
              style={{
                cursor: "pointer",
                alignItems: "center",
                padding: "10px 6px",
                display: "flex",
                flexDirection: "column",
                marginRight: "0px",
              }}
            >
              <h2 style={{ color: "#a26fe2" }}>{vendorBids?.length}</h2>
              <h6 style={{ color: "#a26fe2" }}>Total number of vendors</h6>
            </Tag>
          </Card>
        </Col>
        <Col>
          <Card>
            <Tag
              color="blue"
              style={{
                cursor: "pointer",
                alignItems: "center",
                padding: "10px 6px",
                display: "flex",
                flexDirection: "column",
                marginRight: "0px",
              }}
            >
              <h2 style={{ color: "#2b97fe" }}>
                {vendorBids?.filter((bid) => bid?.vendor_bid_id)?.length}
              </h2>
              <h6 style={{ color: "#2b97fe" }}>Total number of Submissions</h6>
            </Tag>
          </Card>
        </Col>
        <Col>
          <Card>
            <Tag
              color="green"
              style={{
                cursor: "pointer",
                alignItems: "center",
                padding: "10px 6px",
                display: "flex",
                flexDirection: "column",
                marginRight: "0px",
              }}
            >
              <h2 style={{ color: "#88d662" }}>
                {"₹"}
                {lowestBid}
              </h2>
              <h6 style={{ color: "#88d662" }}>Lowest Bid</h6>
            </Tag>
          </Card>
        </Col>
        <Col>
          <Card>
            <Tag
              color="red"
              style={{
                cursor: "pointer",
                alignItems: "center",
                padding: "10px 6px",
                display: "flex",
                flexDirection: "column",
                marginRight: "0px",
              }}
            >
              <h2 style={{ color: "#f7545b" }}>
                {"₹"}
                {getHighestBid()}
              </h2>
              <h6 style={{ color: "#f7545b" }}>Highest Bid</h6>
            </Tag>
          </Card>
        </Col>
      </Row>
      <Card>
        <CardBody>
          <div className="">
            <Table
              loading={loading}
              dataSource={vendorBids}
              columns={columns}
              pagination={false}
              scroll={{ x: "max-content" }}
            />
          </div>
        </CardBody>
      </Card>
    </React.Fragment>
  );
}

export default BidDetails;
